/**
 * Motion driven from JavaScript in the app (the Web Animations API, React
 * Flow's camera), in the same curves as the Tailwind tokens a CSS transition
 * uses: `ease-mk` and `ease-mk-in-out` (tailwind.config.js), whose values
 * live in the marketing site's easing module. One set of curves, so a CSS
 * transition and a scripted one move alike.
 */
import { cubicBezier } from 'motion';
import { EASE_MK, EASE_MK_IN_OUT } from '@/Components/Marketing/easing';

/** The strong ease-out, as a WAAPI `easing` string: anything entering. */
export const EASE_OUT = `cubic-bezier(${EASE_MK.join(', ')})`;

/** The strong ease-in-out, as a WAAPI `easing` string: something on screen moving. */
export const EASE_IN_OUT = `cubic-bezier(${EASE_MK_IN_OUT.join(', ')})`;

/** The strong ease-in-out as a function of t, for APIs that take one (React Flow). */
export const easeInOut = cubicBezier(...EASE_MK_IN_OUT);

/**
 * Whether the reader has asked their system for less motion. app.css stops
 * every CSS animation and transition for them; motion started from script
 * is not CSS and has to ask for itself.
 */
export function prefersReducedMotion() {
    return typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
}

/**
 * React Flow `fitView` options for re-framing a graph after an edit (a node
 * added or deleted): the camera glides to the new frame instead of jumping,
 * so the eye can follow where the graph went. A graph's first framing stays
 * instant; there is nothing yet to follow.
 */
export function reframeOptions() {
    return { duration: prefersReducedMotion() ? 0 : 280, ease: easeInOut };
}
